// extracted by mini-css-extract-plugin
export default {"menuJoin":"c-a_en","menuJoin_show":"c-a_eo"};